module.exports = __webpack_public_path__ + "fonts/BebasNeue-Regular.a3c637a.woff2";